package com.solevo.dist.viewmodels

import com.solevo.dist.application.models.DeliveryNote
import com.solevo.dist.application.models.Product
import com.solevo.dist.application.models.ProductItem
import com.solevo.dist.application.models.toProductItem
import com.solevo.dist.network.api.products.ProductRemoteSource
import com.solevo.dist.network.api.user.UserRemoteSource
import com.solevo.dist.util.DateFormatter
import com.solevo.dist.util.StorageUrlResolver
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.collectLatest
import kotlinx.coroutines.flow.filterNotNull
import kotlinx.coroutines.flow.flatMapLatest
import kotlinx.coroutines.launch
import kotlinx.serialization.json.Json
import org.koin.mp.KoinPlatform.getKoin
import kotlinx.datetime.Instant

data class DeliveryNoteUi(
    val id: String = "",
    val pickingDateText: String = "",
    val docUrl: String? = null,
    val pickedItems: List<ProductItem> = emptyList()
)

class DeliveryNoteViewModel(encodedJson: String) {
    private val scope = CoroutineScope(SupervisorJob() + Dispatchers.Default)
    private val productSource: ProductRemoteSource = getKoin().get()
    private val userRemoteSource: UserRemoteSource = getKoin().get()

    private val deliveryNote: DeliveryNote = Json.decodeFromString(encodedJson)

    private val _state = MutableStateFlow(
        DeliveryNoteUi(
            id = deliveryNote.id,
            pickingDateText = DateFormatter.formatAsDayMonthYear(deliveryNote.pickingDate),
            docUrl = deliveryNote.docMetadata?.url
        )
    )
    val state: StateFlow<DeliveryNoteUi> = _state.asStateFlow()

    @OptIn(ExperimentalCoroutinesApi::class)
    fun start() {
        if (_state.value.docUrl.isNullOrBlank()) {
            scope.launch {
                val resolved = StorageUrlResolver.resolveDocUrl(deliveryNote.docMetadata)
                if (!resolved.isNullOrBlank()) {
                    _state.value = _state.value.copy(docUrl = resolved)
                }
            }
        }

        val ids = deliveryNote.pickedItems?.map { it.productId }.orEmpty()
        if (ids.isEmpty()) return

        scope.launch {
            userRemoteSource.currentUser()
                .filterNotNull()
                .flatMapLatest {
                    productSource.getProducts(ids)
                }
                .collectLatest { products ->
                    val items = getPickedItems(products)
                    _state.value = _state.value.copy(pickedItems = items)
                }
        }
    }

    private fun getPickedItems(products: List<Product>): List<ProductItem> {
        return deliveryNote.pickedItems?.map { item ->
            val product = products.firstOrNull { item.productId == it.productId }
            item.toProductItem(product?.getProductName() ?: item.productId)
        }?.sortedBy { it.lineNumber.toInt() } ?: emptyList()
    }
}


